/* eslint max-classes-per-file: 0 */

import {
  KimCriteria as Data,
  KimCriteriaCollection as Collection,
} from '@/typings/api/CollectorPublication'

import { BaseCollectorApiAuth } from '@/api/BaseApiAuth'

export class KimCriteriaApi extends BaseCollectorApiAuth<Data, Collection> {
  protected readonly endpoint = 'kims_criteria';

  protected readonly hasFinishSlash = false;
}
